module.exports = __webpack_public_path__ + "img/SA gaming.0c33a3a2.jpg";